import React, { Fragment, useEffect } from 'react';
import KuroLink from '../common/KuroLink';
import { isMobile, MobileView } from "react-device-detect";
import '../../styles/header.css';

const Header = () => {

    let top = 0;

    useEffect(() => {
        window.addEventListener("scroll", stickyHandler);

        return () => {
            window.removeEventListener("scroll", () => stickyHandler);
        }
    }, []);

    const menuCloseHandler = () => {
        document.querySelector('.header').classList.remove('hb-open');
        document.body.classList.remove('hb-open');
    };

    const stickyHandler = () => {
        if (top < window.pageYOffset && window.pageYOffset > 100) {
            document.querySelector('.header').classList.remove('sticky');
        } else {
            document.querySelector('.header').classList.add('sticky');
        }
        top = window.pageYOffset;
    };

    const menuHandler = (e) => {
        e.target.closest('.header').classList.toggle('hb-open');
        document.body.classList.toggle('hb-open');
    };

    const itemDropHandler = (e) => {
        if (isMobile) {
            if (e.target.closest('.item').classList.contains('open')) {
                e.target.closest('.item').classList.remove('open');
            } else {
                document.querySelectorAll('.header .menu .item').forEach(el => {
                    el.classList.remove('open');
                });
                e.target.closest('.item').classList.add('open');
            }
        }
    };

    return (
        <Fragment>
        <header className="header sticky">
            <div className="banner1">
                <div className="mx-width">
                    <div className="logo">
                        <KuroLink to="/">
                            <svg viewBox="200 250 1300 700"><title>Kuro Gaming</title><polygon fill="#ee2d30" points="850.68 688.03 885.99 611.01 1180.3 611.01 1264.86 556.53 838.61 553.03 850.68 688.03"/><polygon fill="#ee2d30" points="433.12 715.79 274.77 541.21 753.1 54.3 1029.11 54.3 549.72 541.21 706.98 712.95 433.12 715.79"/><polygon fill="#ee2d30" points="809.78 831.25 850.75 879 1099.35 563.66 850.68 563.95 850.68 688.03 756.3 541.21 1426.01 541.21 850.75 1194.56 532.77 830.61 809.78 831.25"/></svg>
                            <div className="text-logo">
                                <svg viewBox="100 500 1550 250"><title>Kuro Gaming</title><path fill="#ed2224" d="M105.21,553h15v56.66L179,553h19.75l-70.65,67.75L204.26,704H184.68l-64.47-70.33V704h-15Z"/><path fill="#ed2224" d="M230.21,553h15v91.11q0,16.21.62,20.21a33.57,33.57,0,0,0,5.25,14.93q4.11,6,12.66,10a39.7,39.7,0,0,0,17.19,4.06,34.08,34.08,0,0,0,14.42-3.18,32,32,0,0,0,11.52-8.83,35.94,35.94,0,0,0,6.8-13.64q1.54-5.75,1.54-23.6V553h15v91.11q0,20.21-3.95,32.68t-15.81,21.7q-11.86,9.22-28.7,9.23-18.27,0-31.31-8.72A42,42,0,0,1,233,675.91q-2.76-8.82-2.77-31.8Z"/><path fill="#ed2224" d="M368.21,553h29.9q25,0,33.88,2.06a38.6,38.6,0,0,1,21.74,13.2q8.36,10.13,8.36,24.93a40.48,40.48,0,0,1-5.76,21.68A36.09,36.09,0,0,1,439.85,629q-10.73,4.77-29.6,4.88l54,70.11H446.09l-54.34-70h-8.54v70h-15Zm15,15v51l25.91.21q15,0,22.27-2.86a23.13,23.13,0,0,0,11.26-9.13,25.31,25.31,0,0,0,4.05-14,24.3,24.3,0,0,0-4.1-13.72,22.81,22.81,0,0,0-10.75-8.82Q425.19,568,409.73,568Z"/><path fill="#ed2224" d="M567.61,548.89q34.36,0,57.52,22.88t23.15,56.33q0,33.14-23.1,56.22T568.84,707.4q-33.65,0-56.8-23t-23.15-55.61a80.28,80.28,0,0,1,10.55-40.32,76.64,76.64,0,0,1,28.76-29.08A77.48,77.48,0,0,1,567.61,548.89Zm.67,14.67A64.61,64.61,0,0,0,513,595.8a65.3,65.3,0,0,0-8.45,33q0,26.91,18.7,45.44a61.65,61.65,0,0,0,45.06,18.53,64.81,64.81,0,0,0,32.59-8.52,61,61,0,0,0,23.38-23.31,65.33,65.33,0,0,0,8.4-32.86,63.72,63.72,0,0,0-8.4-32.49,62.56,62.56,0,0,0-23.63-23.26A64.08,64.08,0,0,0,568.28,563.56Z"/><path fill="#ed2224" d="M882.83,578l-11.72,11.08a89.55,89.55,0,0,0-27.71-18.83A74.8,74.8,0,0,0,814,563.87a70.19,70.19,0,0,0-33.89,8.72,63.38,63.38,0,0,0-24.93,23.65,60.89,60.89,0,0,0-8.84,31.55,62.23,62.23,0,0,0,9.15,32.37,65,65,0,0,0,25.29,24.11A72.91,72.91,0,0,0,816.2,693q23.34,0,39.48-13.13A51.81,51.81,0,0,0,874.81,646h-48.6V631h65.57c-.14,23.6-7.08,42.12-20.83,55.83s-32.13,20.57-55.16,20.57q-42,0-66.43-28.52a75.66,75.66,0,0,1-18.82-50.78,77.74,77.74,0,0,1,10.8-39.92A76.79,76.79,0,0,1,771,559.3q18.82-10.41,42.57-10.41a95,95,0,0,1,36.2,6.92Q866.69,562.74,882.83,578Z"/><path fill="#ed2224" d="M982.37,553,1053,704h-16l-24-50H947.4l-23.72,50H907.16l71.51-151Zm-1.91,31.37L954.54,639h51.71Z"/><path fill="#ed2224" d="M1069.42,704l21.67-151h2.46l61.52,123.9L1216,553h2.43l21.77,151h-14.83l-14.95-108-53.51,108H1153L1098.9,595.19,1084,704Z"/><path fill="#ed2224" d="M1268.21,553h15V704h-15Z"/><path fill="#ed2224" d="M1317.21,704V553h2.73l101.27,115.75V553h15V704h-.79L1333.21,589.66V704Z"/><path fill="#ed2224" d="M1619.19,578l-11.72,11.08a89.59,89.59,0,0,0-27.72-18.83,74.75,74.75,0,0,0-29.35-6.41,70.16,70.16,0,0,0-33.89,8.72,63.31,63.31,0,0,0-24.93,23.65,60.91,60.91,0,0,0-8.85,31.55,62.15,62.15,0,0,0,9.16,32.37,65,65,0,0,0,25.29,24.11,72.88,72.88,0,0,0,35.38,8.77q23.34,0,39.48-13.13A51.85,51.85,0,0,0,1611.17,646h-48V631h64.92c-.13,23.6-7.07,42.12-20.82,55.83s-32.13,20.57-55.17,20.57q-42,0-66.42-28.52a75.66,75.66,0,0,1-18.82-50.78,77.74,77.74,0,0,1,10.8-39.92,76.73,76.73,0,0,1,29.61-28.88q18.82-10.41,42.57-10.41a95,95,0,0,1,36.2,6.92Q1603,562.74,1619.19,578Z"/></svg>
                                <span>Admin</span>
                            </div>
                        </KuroLink>
                    </div>
                </div>
            </div>
            <div className="banner2">
                <div className="mx-width">
                    <div className="menu">
                        <MobileView renderWithFragment="true">
                        <div className="hb-menu" onClick={menuHandler}>
                            <span></span>
                        </div>
                        <div className="menu-mask" onClick={menuCloseHandler}></div>
                        </MobileView>
                        <div className="items">
                            <div className="item drop">
                                <h3 className="pri-4" onClick={itemDropHandler}>Users</h3>
                                <ul className="no-bullets">
                                    <li><KuroLink to="/users/user-list">User List</KuroLink></li>
                                    <li><KuroLink to="/orders">Orders</KuroLink></li>
                                    <li><KuroLink to="/tp-orders">TPOrders</KuroLink></li>
                                </ul>
                            </div>
                            <div className="item">
                                <h3 className="pri-4"><KuroLink to="/products">Products</KuroLink></h3>
                            </div>
                            <div className="item drop">
                                <h3 className="pri-4" onClick={itemDropHandler}>Pre Builts</h3>
                                <ul className="no-bullets">
                                    <li><KuroLink to="/pre-builts/gaming-desktops">Gaming Desktops</KuroLink></li>
                                    <li><KuroLink to="/pre-builts/work-stations">Work stations</KuroLink></li>
                                    <li><KuroLink to="/pre-builts/home-and-office-pc">Home &amp; Office PC</KuroLink></li>
                                    <li><KuroLink to="/pre-builts/small-form-factor-desktops">Small Form Factor Desktops</KuroLink></li>
                                </ul>
                            </div>
                            <div className="item drop">
                                <h3 className="pri-4" onClick={itemDropHandler}>Components</h3>
                                <ul className="no-bullets">
                                    <li><KuroLink to="/pc-components/core">Core Components</KuroLink></li>
                                    <li><KuroLink to="/pc-components/monitors">Monitors</KuroLink></li>
                                    <li><KuroLink to="/pc-components/networking-gear">Networking Gear</KuroLink></li>
                                    <li><KuroLink to="/pc-components/external-devices">External Devices</KuroLink></li>
                                </ul>
                            </div>
                            <div className="item drop">
                                <h3 className="pri-4" onClick={itemDropHandler}>Accessories</h3>
                                <ul className="no-bullets">
                                    <li><KuroLink to="/accessories/keyboards">Keyboards</KuroLink></li>
                                    <li><KuroLink to="/accessories/keyboard-accessories">Keyboard Accessories</KuroLink></li>
                                    <li><KuroLink to="/accessories/mouse">Mouse</KuroLink></li>
                                    <li><KuroLink to="/accessories/mouse-accessories">Mouse Accessories</KuroLink></li>
                                    <li><KuroLink to="/accessories/keyboard-mouse-combo">Keyboard Mouse Combo</KuroLink></li>
                                    <li><KuroLink to="/accessories/streaming-gear">Streaming Gear</KuroLink></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div className="header-spacer"></div>
        </Fragment>
    );
}

export default Header;